module.exports = __webpack_public_path__ + "static/media/extrapickles.84f5ea1f.png";